const PlayerDetails = ({ player }) => {
  return (
    <div className='mt-4'>
      {/* Player Information */}
      <h4>
        {player.name} {player.lastname}
      </h4>
      <p>Email: {player.email}</p>

      {/* Skills Table */}
      <table className='table table-bordered mt-4'>
        <thead>
          <tr>
            <th>Skill</th>
            <th>Context</th>
            <th>Wellness</th>
            <th>Teamwork</th>
            <th>Total</th>
            <th>Day 1 Decision</th>
            <th>Day 45 Decision</th>
          </tr>
        </thead>
        <tbody className='table-group-divider'>
          <tr>
            <td>{player?.playerPoints?.Skills || 0}</td>
            <td>{player?.playerPoints?.Context || 0}</td>
            <td>{player?.playerPoints?.Wellness || 0}</td>
            <td>{player?.playerPoints?.Teamwork || 0}</td>
            <td>
              {Object.values(player?.playerPoints || {}).reduce(
                (a, b) => a + b,
                0,
              ) || 0}
            </td>
            <td>{player?.day1Decision || 'N/A'}</td>
            <td>{player?.day45Decision || 'N/A'}</td>
          </tr>
        </tbody>
      </table>

      {/* Activity Log */}
      <h4 className='h5 mt-5 text-start'>Activity Log</h4>
      {Object.entries(player.gameLog || {}).length > 0 ? (
        <ul className='list-unstyled mt-3 text-start'>
          {Object.entries(player.gameLog || {}).map(([time, task], index) => (
            <li key={`game-log-${index}`} className='m-0 py-2 border-bottom'>
              <code className='bg-light border border-secondary p-1 rounded-2 text-primary me-2'>
                {time.replace('_', ':')}
              </code>{' '}
              {task}
            </li>
          ))}
        </ul>
      ) : (
        <p className='mt-2 text-start'>No activity logged.</p>
      )}
    </div>
  );
};

export default PlayerDetails;
